import { render, staticRenderFns } from "./OperarioForm.vue?vue&type=template&id=1643bfdd"
import script from "./OperarioForm.vue?vue&type=script&lang=js"
export * from "./OperarioForm.vue?vue&type=script&lang=js"
import style0 from "./OperarioForm.vue?vue&type=style&index=0&id=1643bfdd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports